import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_REGULATORY_BODIES_URL = `${process.env.PUBLIC_URL}/api/v1/r/regulatoryBodies`;
export const GET_REGULATORY_BODIES = 'GET_REGULATORY_BODIES';
export const GET_REGULATORY_BODIES_COMPLETED = 'GET_REGULATORY_BODIES_COMPLETED';
export const GET_REGULATORY_BODIES_FAILED = 'GET_REGULATORY_BODIES_FAILED';
export function getRegulatoryBodies() {
  const queryFilter = {
    order: "name ASC"
  };
  return queryAll(GET_REGULATORY_BODIES_URL, queryFilter, GET_REGULATORY_BODIES, GET_REGULATORY_BODIES_COMPLETED, GET_REGULATORY_BODIES_FAILED);
}

export const SEARCH_REGULATORY_BODIES = 'SEARCH_REGULATORY_BODIES';
export const SEARCH_REGULATORY_BODIES_COMPLETED = 'SEARCH_REGULATORY_BODIES_COMPLETED';
export const SEARCH_REGULATORY_BODIES_FAILED = 'SEARCH_REGULATORY_BODIES_FAILED';
export const searchRegulatoryBodies = querySearch(GET_REGULATORY_BODIES_URL, SEARCH_REGULATORY_BODIES, SEARCH_REGULATORY_BODIES_COMPLETED, SEARCH_REGULATORY_BODIES_FAILED,
  ['name']);

export const GET_REGULATORY_BODY = 'GET_REGULATORY_BODY';
export const GET_REGULATORY_BODY_COMPLETED = 'GET_REGULATORY_BODY_COMPLETED';
export const GET_REGULATORY_BODY_FAILED = 'GET_REGULATORY_BODY_FAILED';
export function getRegulatoryBody({regulatoryBodyId}) {
  return queryOne(GET_REGULATORY_BODIES_URL, {where: {regulatoryBodyId}}, GET_REGULATORY_BODY, GET_REGULATORY_BODY_COMPLETED, GET_REGULATORY_BODY_FAILED);
}

const REGULATORY_BODY_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/regulatoryBody`;
export const ADD_REGULATORY_BODY = 'ADD_REGULATORY_BODY';
export const ADD_REGULATORY_BODY_COMPLETED = 'ADD_REGULATORY_BODY_COMPLETED';
export const ADD_REGULATORY_BODY_FAILED = 'ADD_REGULATORY_BODY_FAILED';
export const addRegulatoryBody = command(REGULATORY_BODY_ACTION_URL + '/addRegulatoryBody', ADD_REGULATORY_BODY, ADD_REGULATORY_BODY_COMPLETED, ADD_REGULATORY_BODY_FAILED);

export const UPDATE_REGULATORY_BODY = 'UPDATE_REGULATORY_BODY';
export const UPDATE_REGULATORY_BODY_COMPLETED = 'UPDATE_REGULATORY_BODY_COMPLETED';
export const UPDATE_REGULATORY_BODY_FAILED = 'UPDATE_REGULATORY_BODY_FAILED';
export const updateRegulatoryBody = command(REGULATORY_BODY_ACTION_URL + '/updateRegulatoryBody', UPDATE_REGULATORY_BODY, UPDATE_REGULATORY_BODY_COMPLETED, UPDATE_REGULATORY_BODY_FAILED);

export const DELETE_REGULATORY_BODY = 'DELETE_REGULATORY_BODY';
export const DELETE_REGULATORY_BODY_COMPLETED = 'DELETE_REGULATORY_BODY_COMPLETED';
export const DELETE_REGULATORY_BODY_FAILED = 'DELETE_REGULATORY_BODY_FAILED';
export const deleteRegulatoryBody = command(
  REGULATORY_BODY_ACTION_URL + '/deleteRegulatoryBody',
  DELETE_REGULATORY_BODY,
  DELETE_REGULATORY_BODY_COMPLETED,
  DELETE_REGULATORY_BODY_FAILED
);

export const SHOW_DELETE_REGULATORY_BODY_MODAL = 'SHOW_DELETE_REGULATORY_BODY_MODAL';
export function showDeleteRegulatoryBodyModal(regulatoryBody) {
  return {type: SHOW_DELETE_REGULATORY_BODY_MODAL, payload: regulatoryBody};
}

export const HIDE_DELETE_REGULATORY_BODY_MODAL = 'HIDE_DELETE_REGULATORY_BODY_MODAL';
export function hideDeleteRegulatoryBodyModal() {
  return {type: HIDE_DELETE_REGULATORY_BODY_MODAL};
}



// WEBPACK FOOTER //
// ./src/RegulatoryBody/actions.js